<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="pa-0 mt-0 chat-drawer-container fluid">      
      <template v-if="showSaksi">
        <index-saksi></index-saksi>
      </template>      
      <template v-else>
        <index-general></index-general>
      </template>      
    </v-container>
  </v-slide-y-transition>  
</template>
<script>
import IndexGeneral  from './main';
import IndexSaksi  from './main-saksi';
import User from '@/util/models/User';


export default {
  components: {
    IndexGeneral,
    IndexSaksi,
  },
  data () {
    return {
      roles : User.roles()
    };
  },
  computed: {    
    showSaksi () {
      return this.roles.includes('saksi') || this.roles.includes('korsak') || this.roles.includes('dpc');
    },           
  },  
};
</script>

